'use strict';

import TourHelp from './tour-help.component';
import './tour-help.css';

const TourHelpModule = angular
    .module('angular-tour-help', [])
    .component('uiTourHelp', TourHelp)
    .name;

export default TourHelpModule;



// WEBPACK FOOTER //
// ./src/app/common/core/util/help/tour-help/tour-help.module.js